import ky from "ky"

export const api = ky.create({
	prefixUrl: `${import.meta.env.VITE_PUBLIC_API_URL}/v1`,
	credentials: "include",
})
